const WHITESPACE = /\s+/;
const DIACRITICS = /[\u0300-\u036f]/g;
const MAX_TOKENS = 10;

function normalizeForSearch(value: string | null | undefined): string {
  return (value ?? '').toLowerCase().normalize('NFD').replace(DIACRITICS, '');
}

export function tokenizeSearch(search: string | null | undefined): string[] {
  const tokens = normalizeForSearch(search)
    .split(WHITESPACE)
    .filter((token) => token.length > 0);
  return [...new Set(tokens)].slice(0, MAX_TOKENS);
}

export function matchesTokens(tokens: string[], ...fields: (string | null | undefined)[]): boolean {
  if (tokens.length === 0) {
    return true;
  }
  const haystacks = fields.map(normalizeForSearch);
  return tokens.every((token) => haystacks.some((haystack) => haystack.includes(token)));
}
